import React from 'react';
import { FormattedMessage } from 'react-intl';

import css from './SizeModalTabs.css';

const SkiSticks = ({ intl }) => {
  return (
    <div className={css.sections}>
      <div className={css.wrapper}>
        <p className={css.content} dangerouslySetInnerHTML={{ __html: intl.formatMessage({ id: 'SizesModal.SkiSticksTab.1sectionContent' }) }} />
        <div className={css.tableWrapper}>
          <table className={css.table}>
            <thead>
              <tr>
                <th><FormattedMessage id="SizesModal.SkiSticksTab.size" /></th>
                <th><FormattedMessage id="SizesModal.SkiSticksTab.sticksSize" /></th>
              </tr>
            </thead>
            <tbody>
              <tr><td>140</td><td>90</td></tr>
              <tr><td>145</td><td>95</td></tr>
              <tr><td>150</td><td>100</td></tr>
              <tr><td>155</td><td>105</td></tr>
              <tr><td>160</td><td>110</td></tr>
              <tr><td>165</td><td>115</td></tr>
              <tr><td>170</td><td>120</td></tr>
              <tr><td>175</td><td>125</td></tr>
              <tr><td>180</td><td>130</td></tr>
              <tr><td>185</td><td>135</td></tr>
              <tr><td>190</td><td>140</td></tr>
              <tr><td>195</td><td>145</td></tr>
              <tr><td>200</td><td>150</td></tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={css.wrapper}>
        <p className={css.content}>
          <FormattedMessage id="SizesModal.SkiSticksTab.2sectionContentA" />
        </p>
      </div>
    </div>
  )
}

export default SkiSticks;